// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2Dydj","head":"Table_head__2EtkI","col":"Table_col__upmfb"};